import { Typography } from "@packages/ds";
import styled from "styled-components";

import { semiBoldAlias } from "Libs/theme";

export const Layout = styled.div<{ gridColumn: string }>`
  grid-column: ${props => props.gridColumn};
  display: flex;
  flex-direction: column;
  font-size: 15px;
  line-height: 18px;
  ${semiBoldAlias({ fontWeight: 400 })};
`;

export const Label = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
  align-items: center;
  font-style: normal;
  font-size: 13px;
  line-height: 19px;
  margin-top: 5px;
  text-transform: capitalize;
  color: var(--mode-text-neutral-weakest);
  ${semiBoldAlias()};

  [role="dialog"] {
    text-transform: none;
  }
`;

export const Value = styled(Typography.BodyText)<{ shouldCapitalize: boolean }>`
  ${({ shouldCapitalize }) =>
    shouldCapitalize && "text-transform: capitalize;"};
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;

  & > div {
    max-height: 16px;
    margin-left: 4px;
  }
`;
